/**
 * lib-core
 *
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ItemRegistry } from "@adapptio/lib-shared";
import { TGenericViewComponentDefinition } from "@adapptio/lib-components";

/**
 * Component Definition Registry
 */
export type IComponentDefRegistry = ItemRegistry<TGenericViewComponentDefinition>;

export class ComponentDefRegistry extends ItemRegistry<TGenericViewComponentDefinition> {}
